import styled from 'styled-components'

export const AlertContainer = styled.div`
	width: ${window.innerWidth + 'px'};
	height: 40px;
	background-color: #c22a58;
	color: #fff;
	font-weight: 500;
	position: absolute;
	z-index: 1050;
	top: 100%;
	display: grid;
	text-align: center;
	place-items: center;

	animation: fadeAlert 0.4s;

	@keyframes fadeAlert {
		0% {
			opacity: 0;
			top: 110%;
		}
		100% {
			opacity: 1;
			top: 100%;
		}
	}

	span {
		font-family: 'Montserrat', 'Arial', 'Roboto', sans-serif;
	}
`
